module.exports = __webpack_public_path__ + "img/euro_normal.29b8396f.svg";